import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import { NotificationManager } from "react-notifications";
import { getErrorMessage, getPaginatedUrlWithSearchParams } from "store/helper";
import { defaultMetaObj, initialCallRecordState } from "store/constants";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";

const { callRecordEndPoint } = endPoints;

export const fetchAllCallRecord = createAsyncThunk(
  "callRecord/fetchAllCallRecord",
  async (
    {
      page,
      limit,
      searchParamsObj = {},
    }: { page: number; limit?: number; searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: page,
      limit,
      endpoint: callRecordEndPoint,
      searchParams: {
        ...searchParamsObj,
      },
    });

    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      return response.data;
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCallRecord = createAsyncThunk(
  "callRecord/deleteCallRecord",
  async ({ callRecordId }: any, { rejectWithValue }) => {
    try {
      const response: any = await crudService.delete(
        callRecordEndPoint,
        callRecordId
      );

      if (response.status === 204) {
        NotificationManager.success("Call Record Deleted Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const callRecordSlice = createSlice({
  name: "callRecord",
  initialState: initialCallRecordState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all call records
    builder
      .addCase(fetchAllCallRecord.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchAllCallRecord.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.callRecord = action.payload?.objects as any[];
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchAllCallRecord.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.callRecord = [];
          state.meta = defaultMetaObj;
        }
      );

    // delete Call Record
    builder
      .addCase(deleteCallRecord.pending, (State) => {
        State.loading = true;
      })
      .addCase(
        deleteCallRecord.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        deleteCallRecord.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const callRecordReducer = callRecordSlice.reducer;
